import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: 60,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'start',
      paddingLeft: 15,
      paddingTop: 15,
    },
  },
  emailUsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 30,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start',
      gap: 20,
      marginTop: 10,
      marginBottom: 20,
      width: '94%',
    },
  },
  phoneContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: 5,
    },
  },
  title: {
    fontWeight: 'bold',
    color: theme.palette.gray.efesDarkGray,
    [theme.breakpoints.down('xl')]: {
      fontSize: 40,
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 36,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  phoneText: {
    fontSize: 24,
    color: '#6e6e6e',
    [theme.breakpoints.down(1660)]: {
      fontSize: 22,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  phone: {
    fontSize: 34,
    fontWeight: 'bold',
    color: theme.palette.gray.efesDarkGray,
    [theme.breakpoints.down(1660)]: {
      fontSize: 32,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  button: {
    width: '15.25rem',
    height: '4.25rem',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('md')]: {
      width: '10rem',
      height: '3.6rem',
      fontSize: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 48,
    },
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
}));

export default useStyles;
